/**
 * insiIdentityMapping (T08) — shared helpers mapping INSi traits (`tiq`) onto the
 * patient form's name/identity model, so the LockedIdentityCard and the
 * CreatePatientDialog prefill agree on a single source of truth.
 *
 * Name mapping (tech_design_spec §6.1):
 *   nomNaissance  → name.lastName   (birth surname)
 *   listePrenom   → name.firstName  (the FULL list of prénoms; the form holds
 *                                    firstName as an array). INSi has no "middle
 *                                    name" concept — all given names are prénoms,
 *                                    so middleName stays empty.
 *
 * Sexe mapping: the INSi wire uses 'M' / 'F'; the patient form's `gender` field
 * uses the app's `sexData` values ('male' / 'female' — lib/enums/sex).
 */
import { SEX } from 'lib/enums/sex';

/** INSi sexe ('M' | 'F') → patient form gender value ('male' | 'female'). */
export const insiSexeToGender = (sexe) => {
  if (sexe === 'M') return SEX.male;
  if (sexe === 'F') return SEX.female;
  return undefined;
};

/** Patient form gender → INSi sexe (for re-search prefill, future use). */
export const genderToInsiSexe = (gender) => {
  if (gender === SEX.male) return 'M';
  if (gender === SEX.female) return 'F';
  return undefined;
};

/**
 * Build the patient `name` object from INSi traits. ALL prénoms go into the
 * `firstName` array (INSi models a list of prénoms, with no "middle name").
 * @param {{ nomNaissance?: string, listePrenom?: string[] }} traits
 */
export const insiTraitsToName = (traits) => {
  const prenoms = (traits?.listePrenom || []).filter(Boolean);
  return {
    firstName: prenoms.length ? prenoms : [''],
    lastName: traits?.nomNaissance || '',
    middleName: '',
    suffix: '',
  };
};
